import {AppTitle} from "shared/UI/UIKit/Title";
import type {AppModalTileProps} from "./ModalTitle.types";

export const AppModalTitle = (props: AppModalTileProps) => {
  return (
    <AppTitle level={1} {...props}/>
  );
};
